import { render, staticRenderFns } from "./DatePicker2.vue?vue&type=template&id=5cc20a14&"
import script from "./DatePicker2.vue?vue&type=script&lang=js&"
export * from "./DatePicker2.vue?vue&type=script&lang=js&"
import style0 from "./DatePicker2.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDatePicker,VIcon,VMenu})
